import { render, staticRenderFns } from "./help-page.vue?vue&type=template&id=23dd8380"
import script from "./help-page.vue?vue&type=script&lang=js"
export * from "./help-page.vue?vue&type=script&lang=js"
import style0 from "./help-page.vue?vue&type=style&index=0&id=23dd8380&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports